module.exports = __webpack_public_path__ + "static/media/telescope.f7e105ec.svg";